
import { useTheme } from "@/components/theme-provider"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ position, ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <div role="region" aria-label="Notifiche">
      <Sonner
        position="bottom-center"
        theme={theme as ToasterProps["theme"]}
        className="toaster group"
        visibleToasts={3}
        toastOptions={{
          classNames: {
            toast:
              "group toast group-[.toaster]:bg-background group-[.toaster]:border-border group-[.toaster]:shadow-lg",
            title:
              "group-[.toast]:text-foreground",
            description:
              "group-[.toast]:text-muted-foreground",
            actionButton:
              "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
            cancelButton:
              "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
            success:
              "group-[.toaster]:!bg-green-50 group-[.toaster]:!text-green-800 group-[.toaster]:!border-green-300",
            error:
              "group-[.toaster]:!bg-red-50 group-[.toaster]:!text-red-800 group-[.toaster]:!border-red-300",
          },
        }}
        {...props}
      />
    </div>
  )
}

export { Toaster }
